// Shared image error handler — hides broken images so the underlying
// initial / placeholder background shows through.
// Usage: <img src={url} onError={hideOnError} />

export const hideOnError = (e) => {
  if (!e?.target) return;
  e.target.onerror = null;
  e.target.style.display = "none";
};

// A 1x1 transparent SVG data URI as a graceful fallback when we DO want
// an <img> element to remain in place (preserves layout).
export const FALLBACK_SVG =
  "data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3C/svg%3E";

export const replaceOnError = (e) => {
  if (!e?.target) return;
  e.target.onerror = null;
  e.target.src = FALLBACK_SVG;
};
